// Yetki & Departman Taşıma (RTDB → SQL, süper admin) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.permissionMigration';

export const superAdminPermissionMigrationGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Yetki & Departman Taşıma nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Firebase RTDB\'deki personel ekran yetkilerini, departmanları ve arşiv verisini şirketlerin kendi SQL veritabanına aktarırsınız. Taşıma geri alınamaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yetki & Departman Taşıma'),
    form: t(`${G}.regions.form`, 'Toplu Taşıma (Tüm Şirketler)'),
    list: t(`${G}.regions.list`, 'Tek şirket: seç, önizle, taşı'),
    footer: t(`${G}.regions.footer`, 'Sonuç'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ne taşınır?'),
      text: t(`${G}.s1.text`, 'Personel ekran yetkileri (WMS ekran yetkileri ve yönetici panel yetkileri dahil) ve departmanlar şirketin SQL veritabanına yazılır. SQL\'de henüz kendi tablosu olmayan veriler (şube atamaları, personel finans hareketleri, etkinlik / ajanda, bildirim, sözleşme, kullanım istatistiği) kayıpsız JSON olarak arşiv tablosuna (LegacyMigrationRecords) taşınır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Bu geçici bir araçtır: yetkiler hâlâ web\'den Firebase\'e yazıldığı için geçiş sırasında araç yeniden çalıştırılmalıdır.'),
        t(`${G}.s1.tip2`, 'Hızlı Satış / PYK yetkileri taşınmaz; bunların asıl kaynağı zaten SQL\'dir.'),
        t(`${G}.s1.tip3`, '"Taşı" düğmelerini yalnız süper admin kullanabilir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Toplu taşıma'),
      text: t(`${G}.s2.text`, '"Tüm Şirketleri Taşı" → onay penceresinde "Tümünü Taşı" ile tüm şirketlerin yetki, departman ve arşiv verisi sırayla taşınır. Bu düğmeden önce ayrı bir tarama adımı yoktur; doğrudan yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Her şirket bitince ilerleme çubuğu, canlı log ve sayaç kartları (Şirket, Hatalı Şirket, Yetki, Departman, Arşiv) güncellenir.'),
        t(`${G}.s2.tip2`, 'Hata veren şirket atlanır, diğerleri devam eder; sonunda Şirket ID ve hata metniyle listelenir. Düzeltip yeniden çalıştırabilirsiniz.'),
        t(`${G}.s2.tip3`, 'Şirket sayısına göre uzun sürebilir; taşıma sürerken sayfayı kapatmayın. Taşıma tarayıcıdan şirket şirket yürütülür; sayfa kapanırsa kalan şirketler taşınmaz.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Tek şirket: seçin ve önizleyin'),
      text: t(`${G}.s3.text`, '"Şirket ara / seç" kutusundan şirketi seçip "Tara (Önizle)" düğmesine basın. Yetki Satırı, Yetkili Personel, Departman ve Ekran Tipi sayıları ile ekran tiplerine göre dağılım görünür. Tarama hiçbir şey yazmaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Şirkette taşınacak yetki veya departman yoksa "SQL\'e Taşı" düğmesi kapalı kalır.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Taşıyın: bu işlem geri alınamaz'),
      text: t(`${G}.s4.text`, '"SQL\'e Taşı" → onay penceresinde "Taşı" ile veriler SQL\'e yazılır. Geri alma düğmesi yoktur: SQL\'de zaten olan kayıtlar RTDB\'deki verilerle güncellenir (üzerine yazılır), olmayanlar eklenir. Taşımadan önce önizlemedeki sayıları kontrol edin.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tekrar çalıştırmak güvenlidir (idempotent): aynı kayıt ikinci kez eklenmez. Ancak SQL\'de sonradan değiştirilmiş yetkiler RTDB\'deki eski değerle ezilebilir.'),
        t(`${G}.s4.tip2`, 'Yetkiler parça parça gönderilir; bir şirket yarıda hata verirse o ana kadar yazılan parçalar kalır. Hatayı giderip aynı şirketi yeniden taşıyın.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Sonucu okuyun'),
      text: t(`${G}.s5.text`, 'Sonuç tablosu Yetkiler, Departmanlar ve Arşiv (tür tür) için Toplam, Eklendi, Güncellendi ve Hata sayısını gösterir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Orphan uid: yetkisi olan personel merkezi kullanıcı listesinde (SystemUsers) bu şirkete bağlı bulunamadı; bu yetkiler yazılmaz. Önce Kullanıcı Taşıma\'yı tamamlayıp aracı yeniden çalıştırın.'),
      ],
    },
  ],
});
